import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import localizedFormat from "dayjs/plugin/localizedFormat";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

export const dayJS = dayjs.extend(utc);
dayJS.extend(isBetween);
dayJS.extend(localizedFormat);
dayJS.extend(timezone);

const isDayJSObject = date => {
  return dayJS.isDayjs(date);
};
// converts a date from UTC to local offset. returns a dayjs date object.
export const utcToLocal = date => {
  return dayJS(date).add(dayJS().utcOffset(), "minutes");
};

// converts a date from local offset to UTC time. returns a dayjs date object.
export const localToUTC = date => {
  return dayJS(date).utc();
};

export const todayDateUTC = () => {
  return dayJS().utc();
};

export const endOfToday = () => {
  return dayJS().endOf("day");
};

export const firstDateOfYear = date => {
  return date ? date.startOf("year") : dayJS().startOf("year");
};

export const formattedDateString = date => {
  return date ? dayjs(date).format("YYYY-MM-DD HH:mm:ss") : null;
};

export const currentMonth = date => {
  return isDayJSObject(date) ? date.month() + 1 : dayJS(date).month() + 1;
};

export const currentYear = date => {
  return isDayJSObject(date) ? date.year() : dayJS(date).year();
};

export const addMaxSecondsToTime = date => {
  return date.get("second") !== 59 ? date.set("seconds", 59) : date;
};

export const isTimeZoneUTC = date => {
  const formattedDate = date.format();
  const timeZone = formattedDate.slice(-6);

  return timeZone === "+00:00";
};

export const numberOfDays = (firstDate, secondDate) => {
  if (isDayJSObject(firstDate) && isDayJSObject(secondDate)) {
    return secondDate.diff(firstDate, "day");
  }

  return secondDate.diff(firstDate, "day");
};

export const numberOfMonths = (firstDate, secondDate) => {
  if (isDayJSObject(firstDate) && isDayJSObject(secondDate)) {
    return secondDate.diff(firstDate, "month");
  }

  return dayJS(secondDate).diff(dayJS(firstDate), "month");
};


export const isWithinDateRange = (currentDate, startDate, endDate) => {
  const newCurrentDate = dayJS.tz(currentDate, "UTC");

  return (
    newCurrentDate.diff(startDate, "s") >= 0 &&
    newCurrentDate.diff(endDate, "s") <= 0
  );
};

export const formatLocalDate = date => {
  return date ? dayjs.utc(date).local().format("DD MMM YYYY") : "—";
}
